import { createReducerContext } from '../../../../utils/create-reducer-context';
import { ACTION_TYPES, SubmissionSearchReducer, SubmissionSearchState } from './submission-search-reducer';

const initialState: SubmissionSearchState = {
    parameters: { page: 0, pageSize: 10, statusIds: [], types: [] },
    searchTrigger: 0,
    ready: false,
    filtersOpen: false,
    periodErrors: {},
    statuses: [],
    vehicles: [],
    refreshVersion: 0,
};

const { Provider: SubmissionSearchProvider, useStateContext: useSubmissionSearchState, useDispatchContext: useSubmissionSearchDispatch } =
    createReducerContext('SubmissionSearch', SubmissionSearchReducer, initialState);

export { SubmissionSearchProvider, useSubmissionSearchState, useSubmissionSearchDispatch, ACTION_TYPES };
